import { put, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import { Types, Creators as CreditCardCreators } from '../../reducers/creditCard';
import { getState } from '../../utils/getState';

function* removeCreditCard() {
  try {
    const { creditCard, checkout } = yield select(getState);
    const selected = creditCard.getIn(['creditCard']);
    const restCreditCards = Object.keys(creditCard.getIn(['creditCards']))
      .filter((key) => key !== selected.sequencia.toString())
      .map((key, i) => ({ ...creditCard.getIn(['creditCards', [key]]), sequencia: i + 1 }));
    const balance = restCreditCards.reduce((acc, item) => acc + parseFloat(item.valor || 0), 0);
    const result = { totalPending: creditCard.getIn(['totalValueOrder']) - balance, creditCards: {} };

    if (restCreditCards.length === 1) {
      result.creditCards['1'] = {
        ...restCreditCards[0],
        valor: creditCard.getIn(['totalValueOrder']),
        installment: { parcelas: checkout.getIn(['payment', 'parcelas']) || [] },
        updateAt: new Date().getTime(),
      };
      result.totalPending = 0;
    } else {
      restCreditCards.forEach(function cb(item) {
        result.creditCards[item.sequencia] = { ...item, updateAt: new Date().getTime() };
      });
    }

    yield put(CreditCardCreators.removeCreditCardSuccess({ ...result }));
  } catch (error) {
    yield put(CreditCardCreators.removeCreditCardError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.REMOVE_CREDIT_CARD_REQUEST, removeCreditCard);
}
